module.exports = __webpack_public_path__ + "img/backdrop.3957df79.png";